import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from 'utils/formatHelper';

export interface ChartDataType {
  name: string;
  total?: number[];
  stack?: string;
  fontSize?: number;
}

export interface BarChartWithLineProps {
  valueName?: string[] | string;
  color?: string[];
  className?: string;
  rotateLabel?: boolean;
  title?: string;
  subTitle?: string;
  yAxisName?: boolean;
  dataTable?: string[];
  dataBar?: number[];
  dataLine?: number[];
}

function CustomBarWithLineChart({ yAxisName = true, ...props }: BarChartWithLineProps) {
  var option: EChartsOption;

  const screenWidth = window.screen.width;

  //=====================================CHUYỂN NGÔN NGỮ=====================================//
  const { t } = useTranslation();

  option = {
    title: {
      text: props.title,
      subtext: props.subTitle,
      right: 'center',
      textStyle: {
        fontFamily: 'roboto',
      },
      subtextStyle: {
        fontFamily: 'roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        color: props.color ? props.color[0] : '#5AC29C',
      },
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontFamily: 'inherit',
        fontSize: 12,
      },
      borderRadius: 3,
      borderWidth: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 1,
      shadowBlur: 3,
      shadowColor: 'rgba(0, 0, 0, 0.25)',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#C5DFEB',
          fontFamily: 'roboto',
          fontSize: 10,
          fontWeight: 400,
        },
      },
      className:
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!rounded-[1px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!w-[19px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!h-[12px] ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!font-semibold ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!text-textColor',

    },
    color: props.color ? props.color : ['#5AC29C', '#5281BB'],
    legend: {
      orient: 'vertical',
      left: "left",
      itemGap: 5,
      textStyle: {
        fontFamily: 'roboto',
        fontSize: 10,
        color: '#77838F',
      },
    },
    toolbox: {
      show: false,
      feature: {
        dataView: { readOnly: false },
        restore: {},
        saveAsImage: {},
      },
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: props.dataTable,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],

    yAxis: [
      {
        type: 'value',
        // name: 'Precipitation',
        // min: 0,
        // max: 250,
        // interval: 50,
        // axisLabel: {
        //   formatter: '{value} ml'
        // }
      },
    ],

    series: [
      {
        name: 'Lượt đánh giá',
        type: 'bar',
        tooltip: {
          valueFormatter: function (value) {
            return value + '';
          }
        },
        data: props.dataBar
      },
      {
        name: 'Lượt ghé thăm',
        type: 'line',
        // yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value) {
            return value + '';
          }
        },
        label: {
          show: true,
          position: 'top'
        },
        data: props.dataLine
      }
    ]
  };

  return <ReactECharts option={option} className={props.className} />;
}

export default CustomBarWithLineChart;
